// API Configuration - dynamic and environment-safe
export function resolveApiBaseUrl(): string {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (typeof window !== 'undefined') {
    const { protocol, hostname, port } = window.location;
    const frontendPort = port ? parseInt(port, 10) : NaN;

    // Common frontend dev-server ports should still call the backend on :5000.
    if ([3000, 3001, 3002, 4173, 5173].includes(frontendPort)) {
      return `${protocol}//${hostname}:5000`;
    }

    return port ? `${protocol}//${hostname}:${port}` : `${protocol}//${hostname}`;
  }

  return 'http://localhost:5000';
}

export const API_BASE_URL = resolveApiBaseUrl();

if (process.env.NODE_ENV !== 'production') {
  console.info('[API] base url set to', API_BASE_URL);
}

export const buildApiPath = (endpoint: string): string => {
  const clean = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `/api/${clean}`;
};

export const getApiUrl = (endpoint: string): string => {
  return `${API_BASE_URL}${buildApiPath(endpoint)}`;
};
